import { type AppDispatch } from '../../store'
import { getSurveyByIdApi } from '../../store/slices/SurveyTemplateSlice/apis'
import { setEditableSurvey } from '../../store/slices/SurveyTemplateSlice'

export const refreshEditableSurveyBaseline = async (
  dispatch: AppDispatch,
  templateId: string
): Promise<void> => {
  const refreshedSurvey = await dispatch(getSurveyByIdApi({ urlId: templateId })).unwrap()
  dispatch(setEditableSurvey(refreshedSurvey))
}
